<template>
    <div>
        <hr class="my-4" />
        <h6 class="heading-small text-muted mb-4">ข้อมูลที่อยู่ใบแจ้งหนี้และใบเสร็จรับเงิน</h6>
        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> คุณต้องการคิดคิดภาษีมูลค่าเพิ่มหรือไม่
                    </label>
                    <div class="col-lg-12">
                        <b-form-group>
                            <b-form-radio-group v-model="agent.vat">
                                <b-form-radio :value="1">คิดภาษีมูลค่าเพิ่ม</b-form-radio>
                                <b-form-radio :value="0">ไม่คิดภาษีมูลค่าเพิ่ม</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ประเภท
                    </label>
                    <div class="col-lg-12">
                        <b-form-group>
                            <b-form-radio-group v-model="agent.receiptType">
                                <b-form-radio value="person">บุคคลธรรมดา</b-form-radio>
                                <b-form-radio value="company">นิติบุคคล</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ชื่อ
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="ชื่อ"
                        :class="{ 'is-invalid': submitFormTax && $v.agent.receiptName.$error }"
                        v-model="agent.receiptName"
                    />
                    <label
                        v-if="submitFormTax && !$v.agent.receiptName.required"
                        class="invalid-feedback"
                    >กรุณากรอกชื่อ</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger" v-if="agent.receiptType == 'company'">*</span> ชื่อบริษัท (กรณีเป็นนิติบุคคล)
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="ชื่อบริษัท (กรณีเป็นนิติบุคคล)"
                        :class="{ 'is-invalid': submitFormTax && $v.agent.companyName.$error }"
                        v-model="agent.companyName"
                    />
                    <label
                        v-if="submitFormTax && !$v.agent.companyName.required"
                        class="invalid-feedback"
                    >กรุณากรอกชื่อบริษัท (กรณีเป็นนิติบุคคล)</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> อีเมล (สำหรับจัดส่งเอกสาร)
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="อีเมล (สำหรับจัดส่งเอกสาร)"
                        :class="{ 'is-invalid': submitFormTax && $v.agent.receiptEmail.$error }"
                        v-model="agent.receiptEmail"
                    />
                    <label v-if="submitFormTax && !$v.agent.receiptEmail.email" class="invalid-feedback">
                        รูปแบบอีเมล (สำหรับจัดส่งเอกสาร) ไม่ถูกต้อง
                    </label>
                    <label v-if="submitFormTax && !$v.agent.receiptEmail.required" class="invalid-feedback">
                        กรุณากรอกอีเมล (สำหรับจัดส่งเอกสาร)
                    </label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> เลขประจำตัวผู้เสียภาษี
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="เลขประจำตัวผู้เสียภาษี"
                        :class="{ 'is-invalid': submitFormTax && $v.agent.tax_id.$error }"
                        v-model="agent.tax_id"
                    />
                    <label class="error invalid-feedback" v-if="!$v.agent.tax_id.minLength">
                        กรุณากรอก"เลขประจำตัวผู้เสียภาษี"อย่างน้อย {{$v.agent.tax_id.$params.minLength.min}} ตัวอักษร
                    </label>
                    <label class="error invalid-feedback" v-if="!$v.agent.tax_id.maxLength">
                        กรุณากรอก"เลขประจำตัวผู้เสียภาษี"ไม่เกิน {{ $v.agent.tax_id.$params.maxLength.max }} ตัวเลข
                    </label>
                    <label v-if="submitFormTax && !$v.agent.tax_id.required" class="invalid-feedback">
                        กรุณากรอกเลขประจำตัวผู้เสียภาษี
                    </label>
                    <label v-if="submitFormTax && !$v.agent.tax_id.checkTax" class="invalid-feedback">
                        กรุณากรอกเลขประจำตัวผู้เสียภาษีให้ถูกต้อง
                    </label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> ที่อยู่
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': submitFormTax && $v.agent.address.$error }"
                        placeholder="ที่อยู่"
                        v-model="agent.address"
                    />
                    <label
                        class="error invalid-feedback"
                        v-if="!$v.agent.address.minLength"
                    >กรุณากรอก"ที่อยู่"อย่างน้อย {{$v.agent.address.$params.minLength.min}} ตัวอักษร</label>
                    <label
                        v-if="submitFormTax && !$v.agent.address.required"
                        class="invalid-feedback"
                    >กรุณากรอกที่อยู่</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> ตำบล/แขวง
                    </label>
                    <AutocompletesAddress
                        :queryInput="agent.state" 
                        :adsTypes="'sub-district'"
                        placeHolder="ตำบล/แขวง"
                        :class="{ 'is-invalid': submitFormTax && $v.agent.state.$error }"
                        @input="agent.state = $event.target.value"
                        @select:item="onSubmitAddress( $event , 'agent' )">
                    </AutocompletesAddress>
                    <label
                        v-if="submitFormTax && !$v.agent.state.required"
                        class="invalid-th-address"
                    >กรุณากรอกตำบล/แขวง</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> อำเภอ/เขต
                    </label>
                    <AutocompletesAddress
                        :queryInput="agent.district" 
                        :adsTypes="'district'"
                        placeHolder="อำเภอ/เขต"
                        :class="{ 'is-invalid': submitFormTax && $v.agent.district.$error }"
                        @input="agent.district = $event.target.value"
                        @select:item="onSubmitAddress( $event , 'agent' )">
                    </AutocompletesAddress>
                    <label
                        v-if="submitFormTax && !$v.agent.district.required"
                        class="invalid-th-address"
                    >กรุณากรอกอำเภอ/เขต</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> จังหวัด
                    </label>
                    <AutocompletesAddress
                        :queryInput="agent.province" 
                        :adsTypes="'province'"
                        placeHolder="จังหวัด"
                        :class="{ 'is-invalid': submitFormTax && $v.agent.province.$error }"
                        @input="agent.province = $event.target.value"
                        @select:item="onSubmitAddress( $event , 'agent')">
                    </AutocompletesAddress>
                    <label
                        v-if="submitFormTax && !$v.agent.province.required"
                        class="invalid-th-address"
                    >กรุณากรอกจังหวัด</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label floater>
                        <span class="text-danger">*</span> รหัสไปรษณีย์
                    </label>
                    <AutocompletesAddress
                        :queryInput="agent.postcode" 
                        :adsTypes="'postcode'"
                        placeHolder="รหัสไปรษณีย์"
                        :class="{ 'is-invalid': submitFormTax && $v.agent.postcode.$error }"
                        @input="agent.postcode = $event.target.value"
                        @select:item="onSubmitAddress( $event , 'agent')">
                    </AutocompletesAddress>
                    <label
                    v-if="submitFormTax && !$v.agent.postcode.required"
                    class="invalid-th-address"
                    >กรุณากรอกรหัสไปรษณีย์</label>

                    <label
                    class="error invalid-th-address"
                    v-if="submitFormTax && !$v.agent.postcode.minLength"
                    >กรุณากรอก"รหัสไปรษณีย์" {{$v.agent.postcode.$params.minLength.min}} หลัก</label>

                    <label
                    class="error invalid-th-address"
                    v-if="submitFormTax && !$v.agent.postcode.maxLength"
                    >กรุณากรอก"รหัสไปรษณีย์" {{$v.agent.postcode.$params.maxLength.max}} หลัก</label>

                    <label
                    class="error invalid-th-address"
                    v-if="submitFormTax && !$v.agent.postcode.numeric"
                    >กรุณากรอกเฉพาะตัวเลข</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> เบอร์โทรศัพท์
                    </label>
                    <input
                        type="number"
                        class="form-control hide-arrow"
                        :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                        placeholder="เบอร์โทรศัพท์"
                        :class="{ 'is-invalid': submitFormTax && $v.agent.tel.$error }"
                        v-model="agent.tel"
                    />
                    <label
                        v-if="submitFormTax && !$v.agent.tel.required"
                        class="invalid-feedback"
                    >กรุณากรอกเบอร์โทรศัพท์</label>
                    <label
                        class="error invalid-feedback"
                        v-if="!$v.agent.tel.minLength"
                    >กรุณากรอก"เบอร์โทรศัพท์"อย่างน้อย {{$v.agent.tel.$params.minLength.min}}ตัวเลข</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> รูปโลโก้
                    </label>
                    <b-form-file 
                        :state="(submitFormTax) ? !$v.agent.logo.file.$error : null"
                        accept=".jpg, .png, .jpeg"
                        placeholder="เลือกรูปภาพ"
                        @change="setImage($event, 'logo')"
                        v-model="agent.logo.file"
                    ></b-form-file>
                    <div class="text-center pt-2" v-if="agent.logo.preview">
                        <img :src="agent.logo.preview" alt="Image" width="150" height="150">
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> รูปลายเซ็น
                    </label>
                    <b-form-file 
                        :state="(submitFormTax) ? !$v.agent.signature.file.$error : null"
                        accept=".jpg, .png, .jpeg"
                        placeholder="เลือกรูปภาพ"
                        @change="setImage($event, 'signature')"
                        v-model="agent.signature.file"
                    ></b-form-file>
                    <div class="text-center pt-2" v-if="agent.signature.preview">
                        <img :src="agent.signature.preview" alt="Image" width="150" height="150">
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> ลายเซ็น
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="ลายเซ็น"
                        :class="{ 'is-invalid': submitFormTax && $v.agent.signatureName.$error }"
                        v-model="agent.signatureName"
                    />
                    <label
                        v-if="submitFormTax && !$v.agent.signatureName.required"
                        class="invalid-feedback"
                    >กรุณากรอก ลายเซ็น</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
  email,
  requiredIf
} from "vuelidate/lib/validators"
import AutocompletesAddress from '@/components/Autocomplete/AddressTH/AutocompleteAddressTH'
import { checkTax } from "@/plugins/posHelper.js";
import { uploadImage } from "@/plugins/imageHelper.js";


export default {
    props:{
        agent: Object
    },
    components:{
        AutocompletesAddress
    },
    data(){
        return{
            submitFormTax: false
        }
    },
    validations(){
        return{
            agent: {
                receiptName: { required },
                receiptEmail: { required, email },
                companyName: { required: requiredIf(function (company) {
                        return company.receiptType == 'company'
                    })
                },
                tax_id:{ required, minLength: minLength(13), maxLength: maxLength(13), checkTax },
                address: { required, minLength: minLength(5) },
                state: { required },
                district: { required },
                province: { required },
                postcode: { required, numeric, minLength: minLength(4), maxLength: maxLength(5) },
                tel: { required, minLength: minLength(9) },
                signatureName: { required },
                logo: { 
                    file: { required: requiredIf(function (data) {
                            return data.preview == ''
                        })
                    }
                },
                signature: { 
                    file: { required: requiredIf(function (data) {
                            return data.preview == ''
                        })
                    }
                }
            }
        }
    },
    methods: {
        submitFormAgentTax(){
            this.submitFormTax = true;
            this.$v.agent.$touch();
        },
        onSubmitAddress( ads , objKey ){
            Object.keys(this[objKey]).forEach(key=>{
            if( ads[key] ){
                this[objKey][key] = ads[key]
            }else if( key == 'state' ){
                this[objKey]['state'] = ads['sub-district']
            }
            else{
                this[objKey][key] = this[objKey][key]
            }
            })
        },
        setImage(e , key) {
            uploadImage(e).then( image => {
                this.agent[key].file = image.file
                this.agent[key].preview = image.preview
            });
        },
    },
}
</script>